'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VDivider = undefined;

var _VDivider = require('./VDivider');

var _VDivider2 = _interopRequireDefault(_VDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VDivider = _VDivider2.default;
exports.default = _VDivider2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VDivider/index.js
// module id = 183
// module chunks = 0